import { formatDistance } from 'date-fns';
import { datoCMSMaterialIcons } from '@/utils/icons';
import { Band } from '@/components/Modules/Band/Band';
import { Breadcrumbs } from '@/components/Breadcrumbs';
import { getQuestionBreadcrumbs } from '@/utils/breadcrumbs';
import type { QuestionContext } from '@/utils/models/question';
import { type QuestionHeaderFragment, useQuestionQuery } from '@/utils/dato/generated';

/**
 * Can only be used in the context of a Question model
 */
const Header = ({ pageContext }: { pageContext: QuestionContext } & QuestionHeaderFragment) => {
  const { data } = useQuestionQuery({ slug: pageContext.slug });

  if (data?.question) {
    return (
      <Band background="#F1F1F7" spacing="medium" contained={true}>
        <div className="px-5 mx-auto max-w-[700px]">
          <Breadcrumbs breadcrumbs={getQuestionBreadcrumbs(data.question)} className="mb-6" />

          <h1 className="text-4xl lg:text-5xl font-serif font-semibold mb-6">
            {data.question.title || 'Untitled FAQ'}
          </h1>
          <p className="text-lg flex items-center gap-2">
            <span
              style={{ fontVariationSettings: "'FILL' 1", color: 'var(--color-base-400)' }}
              className="material-symbols-outlined text-xl leading-none"
            >
              {datoCMSMaterialIcons['clock']}
            </span>
            Updated {formatDistance(new Date(data.question.updatedAt), new Date(), { addSuffix: true })}
          </p>
        </div>
      </Band>
    );
  }

  return null;
};

export default Header;
